/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as sis from './SISApp'
import { componentApi, loadTranslations } from 'common'


export class K12HallpassStuhallpasssummaryApi {
  async LoadHallPassSummaryData(ssyGU : string) : Promise<sis.StudentHallPassSummaryData> {
    return await componentApi.call('sis', 'k12-hallpass-stuhallpasssummary', 'K12HallpassStuhallpasssummaryApi', 'LoadHallPassSummaryData', {
      ssyGU,
    });
  }
  async LoadHallPassStatsData(ssyGU : string, timeframeStr : string) : Promise<sis.StudentHallPassStatsData> {
    return await componentApi.call('sis', 'k12-hallpass-stuhallpasssummary', 'K12HallpassStuhallpasssummaryApi', 'LoadHallPassStatsData', {
      ssyGU,
      timeframeStr,
    });
  }
}
export default new K12HallpassStuhallpasssummaryApi()
